export default {
  path: '/backoffice',
  name: 'Backoffice',
  redirect: '/backoffice/users',
  component: () => import('../layout/admin/Layout.vue'),
  meta: {
    title: 'Addviseo',
    layout: 'backOffice',
  },
  children: [
    {
      path: 'api-tokens',
      name: 'BackofficeApiTokens',
      component: () => import('../views/BackOffice/ApiTokens/ApiTokens.vue'),
      meta: {
        title: 'Tokens API',
      },
    },
    {
      path: 'api-tester',
      name: 'BackofficeApiTester',
      component: () => import('../views/BackOffice/ApiTester/ApiTester.vue'),
      meta: {
        title: 'API Tester',
      },
    },
    {
      path: 'users',
      name: 'BackofficeUsers',
      component: () => import('../views/BackOffice/Users.vue'),
      meta: {
        title: 'Utilisateurs',
      },
    },
    {
      path: 'users/:id',
      name: 'BackofficeUserSheet',
      component: () => import('../views/BackOffice/UserSheet/UserSheet.vue'),
      props: (route) => ({ userId: Number(route.params.id) }),
      meta: {
        title: 'Fiche utilisateur',
      },
    },
    {
      path: 'france-travail',
      name: 'BackofficeFranceTravail',
      component: () => import('../views/BackOffice/Referentials/FranceTravail.vue'),
      meta: {
        title: 'France Travail',
      },
    },
    {
      path: 'rome',
      name: 'BackofficeRome',
      component: () => import('../views/BackOffice/Rome/RomeReferential.vue'),
      meta: {
        title: 'Référentiel ROME',
      },
    },
    {
      path: 'cron-jobs',
      name: 'BackofficeCronJobs',
      component: () => import('../views/BackOffice/CronJobs/CronJobView.vue'),
      meta: {
        title: 'Cron Jobs',
      },
    },
    {
      path: 'blog',
      name: 'BackofficeBlog',
      component: () => import('../views/BackOffice/Blog/Blog.vue'),
      meta: {
        title: 'Blog & ressources',
      },
    },
    {
      path: 'mails',
      name: 'BackofficeMails',
      component: () => import('../views/BackOffice/Mails/MailsView.vue'),
      meta: {
        title: 'Gestion des mails',
      },
    },
    {
      path: 'program-title-mappings',
      name: 'BackofficeProgramTitleMappings',
      component: () => import('../views/BackOffice/ProgramTitleMappings/ProgramTitleMappings.vue'),
      meta: {
        title: 'Noms de prestation',
      },
    },
    {
      path: 'configuration',
      name: 'BackofficeConfiguration',
      component: () => import('../views/BackOffice/Configuration/Configuration.vue'),
      meta: {
        title: 'Configuration',
      },
    },
    {
      path: 'imports',
      name: 'BackofficeImports',
      component: () => import('../views/BackOffice/Imports/Imports.vue'),
      meta: {
        title: 'Imports',
      },
    },
  ],
};
